import EmployeeKpiView from "./pages/EmployeeKpiView";
import KpiReports from "./pages/KpiReports.jsx";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

// Pages
import Login from "./pages/Login.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import VerifyOTP from "./pages/VerifyOTP.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import ChangePassword from "./pages/ChangePassword.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import TaskManagement from "./pages/TaskManagement.jsx";
import Reports from "./pages/Reports.jsx";
import MyProjects from "./pages/MyProjects.jsx";
import KPI from "./pages/Kpi.jsx";
import Policies from "./pages/Policies.jsx";
import Client from "./pages/Client.jsx";
import CreateClient from "./pages/CreateClient.jsx";
import Employees from "./pages/Employees.jsx";
import CreateEmployee from "./pages/CreateEmployee.jsx";
import Ticketing from "./pages/Ticketing.jsx";
import Documents from "./pages/Documents.jsx";
import Profile from "./pages/Profile.jsx";
import EmployeeKpi from "./pages/EmployeeKpi.jsx";
import EmployeeKpiAdmin from "./pages/EmployeeKpiAdmin.jsx";
import KpiSubmissionDetail from "./pages/KpiSubmissionDetail.jsx";
import WeekKpiDetails from "./pages/WeekKpiDetails.jsx";
import UpdateEmployee from "./pages/UpdateEmployee.jsx";
import UpdateClient from "./pages/UpdateClient.jsx";
import CreateProject from "./pages/CreateProject.jsx";
import UpdateProject from "./pages/UpdateProjects.jsx";
import Induction from "./pages/Induction.jsx";
import Feedback from "./pages/Feedback.jsx";
import TA from "./pages/TA.jsx";
import TAList from "./pages/TAList.jsx";
import TAView from "./pages/TAView.jsx";
import TAEdit from "./pages/TAEdit.jsx";
import ManagerPendingRequests from "./pages/ManagerPendingRequests.jsx";
import LeaveApplication from "./pages/LeaveApplication.jsx";
import LeaveStatus from "./pages/LeaveStatus.jsx";
import Announcements from "./pages/Announcements.jsx";
import MisDashboard from "./pages/MisDashboard.jsx";
import ProjectTracker from "./pages/ProjectTracker.jsx";
import MisTracker from "./pages/MisTracker.jsx";
// CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/global.css";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Routes */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mis-dashboard"
            element={
              <ProtectedRoute>
                <MisDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project-tracker"
            element={
              <ProtectedRoute>
                <ProjectTracker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mis-tracker"
            element={
              <ProtectedRoute>
                <MisTracker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcements"
            element={
              <ProtectedRoute>
                <Announcements />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-kpi-view"
            element={
              <ProtectedRoute>
                <EmployeeKpi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-kpi-admin"
            element={
              <ProtectedRoute>
                <EmployeeKpiAdmin />
              </ProtectedRoute>
            }
          />
           <Route
            path="/week-kpi-details/:week"
            element={
              <ProtectedRoute>
                <WeekKpiDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-kpi"
            element={
              <ProtectedRoute>
                <EmployeeKpiView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-kpi-submission/:id"
            element={
              <ProtectedRoute>
                <KpiSubmissionDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          <Route
            path="/leave/apply"
            element={
              <ProtectedRoute>
                <LeaveApplication />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leave/status"
            element={
              <ProtectedRoute>
                <LeaveStatus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manager/attendance-requests"
            element={
              <ProtectedRoute>
                <ManagerPendingRequests />
              </ProtectedRoute>
            }
          />

          <Route
            path="/allocation"
            element={
              <ProtectedRoute>
                <TaskManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/task-management"
            element={
              <ProtectedRoute>
                <TaskManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myprojects"
            element={
              <ProtectedRoute>
                <MyProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/createproject"
            element={
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-project/:id"
            element={
              <ProtectedRoute>
                <UpdateProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kpi-reports"
            element={
              <ProtectedRoute>
                <KpiReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kpi"
            element={
              <ProtectedRoute>
                <KPI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/policies"
            element={
              <ProtectedRoute>
                <Policies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client"
            element={
              <ProtectedRoute>
                <Client />
              </ProtectedRoute>
            }
          />
          <Route
            path="/createclient"
            element={
              <ProtectedRoute>
                <CreateClient />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-client/:id"
            element={
              <ProtectedRoute>
                <UpdateClient />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employees"
            element={
              <ProtectedRoute>
                <Employees />
              </ProtectedRoute>
            }
          />
          <Route
            path="/createemployee"
            element={
              <ProtectedRoute>
                <CreateEmployee />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-employee/:id"
            element={
              <ProtectedRoute>
                <UpdateEmployee />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ticketing"
            element={
              <ProtectedRoute>
                <Ticketing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <ProtectedRoute>
                <Documents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/induction"
            element={
              <ProtectedRoute>
                <Induction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <ProtectedRoute>
                <Feedback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ta"
            element={
              <ProtectedRoute>
                <TA />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ta-list"
            element={
              <ProtectedRoute>
                <TAList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ta/view/:id"
            element={
              <ProtectedRoute>
                <TAView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ta/edit/:id"
            element={
              <ProtectedRoute>
                <TAEdit />
              </ProtectedRoute>
            }
          />
          {/* Redirect root to dashboard if authenticated, login if not */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Catch-all for undefined routes */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
